import { getAuthApiUrl, getStoredSessionToken } from '@/app/services/session.service';

const ADMIN_AUDIT_LOGS_API_PATH = '/api/admin/audit-logs';

function buildResult({ ok, data = null, error = null, message = '' }) {
  return {
    ok,
    data,
    error,
    message,
  };
}

function getAuthHeaders(extraHeaders = {}) {
  const token = getStoredSessionToken();

  if (!token) {
    return extraHeaders;
  }

  return {
    ...extraHeaders,
    Authorization: `Bearer ${token}`,
  };
}

function mapAuditLog(log) {
  return {
    id: log?.id ?? null,
    occurredAt: log?.occurredAt || null,
    tenantId: log?.tenantId || '',
    actorEmail: log?.actorEmail || '',
    actorRole: log?.actorRole || '',
    actionCode: log?.actionCode || '',
    targetType: log?.targetType || '',
    targetId: log?.targetId || '',
    outcome: log?.outcome || '',
    metadata: log?.metadata && typeof log.metadata === 'object' ? log.metadata : {},
  };
}

export async function listAdminAuditLogs({ limit = 12, tenantId = '', actionCode = '', outcome = '' } = {}) {
  try {
    const params = new URLSearchParams();

    if (tenantId) {
      params.set('tenantId', tenantId);
    }
    if (actionCode) {
      params.set('actionCode', actionCode);
    }
    if (outcome) {
      params.set('outcome', outcome);
    }
    if (limit) {
      params.set('limit', String(limit));
    }

    const query = params.toString();
    const response = await fetch(getAuthApiUrl(`${ADMIN_AUDIT_LOGS_API_PATH}${query ? `?${query}` : ''}`), {
      headers: getAuthHeaders(),
    });
    const payload = await response.json().catch(() => null);

    if (!response.ok) {
      return buildResult({
        ok: false,
        error: payload?.error || 'ADMIN_AUDIT_LOGS_UNAVAILABLE',
        message: payload?.message || 'Audit log control plane non disponibili.',
      });
    }

    if (!Array.isArray(payload)) {
      return buildResult({
        ok: false,
        error: 'ADMIN_AUDIT_LOGS_INVALID_PAYLOAD',
        message: 'Payload audit log non valido.',
      });
    }

    return buildResult({
      ok: true,
      data: payload.map(mapAuditLog),
    });
  } catch {
    return buildResult({
      ok: false,
      error: 'ADMIN_AUDIT_LOGS_UNAVAILABLE',
      message: 'Audit log control plane non disponibili.',
    });
  }
}
